import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { StyledSSRow } from "./Styled";

interface SequentialScaleProps {
    minComplete: number;
    maxComplete: number;
}

export const SequentialScale: FC<SequentialScaleProps> = ({
    minComplete,
    maxComplete,
}) => {
    return (
        <FlexContainer
            width="100%"
            gap="24px"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="flex-start"
            style={{ padding: "0 20px 20px" }}
        >
            <PrimaryText fontSize={14} fontWeight="400" lineHeight="140%">
                Послідовний розрахунок — це система нарахування бонусів, в якій
                коефіцієнт зростання послідовно збільшується від мінімального до
                максимального відсотку виконання плану.
            </PrimaryText>

            <FlexContainer
                width="100%"
                gap="12px"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
            >
                {[
                    { label: "Зараховується від:", value: `${minComplete}%` },
                    { label: "Зараховується до:", value: `${maxComplete}%` },
                ].map(({ label, value }) => (
                    <StyledSSRow key={label}>
                        <SecondaryText
                            fontSize={14}
                            fontWeight="400"
                            lineHeight="140%"
                        >
                            {label}
                        </SecondaryText>
                        <PrimaryText
                            fontSize={14}
                            fontWeight="500"
                            lineHeight="120%"
                        >
                            {value}
                        </PrimaryText>
                    </StyledSSRow>
                ))}
            </FlexContainer>
        </FlexContainer>
    );
};
